import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Select } from "antd";
import classnames from "classnames";

const useStyles = makeStyles({
  root: {
    "& .ant-select-arrow": {
      color: "#444444",
      marginTop: "-8px",
    },
    "& .ant-select-clear": {
      marginTop: "-8px",
      lineHeight: 0,
    },
    "&.ant-select-disabled:not(.ant-select-borderless)": {
      "&>.ant-select-selector": {
        border: "2px solid #d9d9d9!important",
      },
    },
    "&.ant-select:not(.ant-select-customize-input) .ant-select-selector": {
      border: "2px solid #444444",
      borderRadius: 30,
      padding: "7px 20px",
      minHeight: 50,
      display: "flex",
      alignItems: "center",

      "@media (max-width: 576px)": {
        minHeight: "auto",
        padding: "0 11px",
      },
    },
    "&.ant-select-single.ant-select-show-arrow .ant-select-selection-search": {
      display: "flex",
      alignItems: "center",
    },
    "&.ant-select-show-search.ant-select-multiple .ant-select-selector input": {
      marginLeft: "-4px!important",
    },
    "&.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input": {
      marginLeft: 8,
    },
  },
  small: {
    "&.ant-select:not(.ant-select-customize-input) .ant-select-selector": {
      height: 40,
      minHeight: 40,
    },
    "& .ant-select-arrow": {
      marginTop: "-5px",
    },
  },
  light: {
    "&.ant-select:not(.ant-select-customize-input) .ant-select-selector": {
      border: "1px solid #0000001A!important",
      borderRadius: "5px!important",
    },
  },
  fullWidth: {
    width: "100%",
  },
  white: {
    "&.ant-select:not(.ant-select-customize-input) .ant-select-selector": {
      border: "none!important",
    },
  },
});

const NGISelect = ({
  allowClear = false,
  size,
  white = false,
  light = false,
  fullWidth = false,
  children,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Select
      {...props}
      className={classnames(
        classes.root,
        size === "small" && classes.small,
        props.className,
        fullWidth && classes.fullWidth,
        light && classes.light,
        white && classes.white
      )}
      allowClear={allowClear}
    >
      {children}
    </Select>
  );
};
export default NGISelect;
